import { Order, PercentRoute, RouteProtocol } from '@tokenlon/v6-sdk'

export function findAllUniqueProtocols(
  routes: PercentRoute[],
): RouteProtocol[] {
  if (!routes || routes.length === 0) return []

  const uniqueProtocols = new Set<RouteProtocol>()

  routes.forEach((pathRoutes) => {
    pathRoutes.forEach((orderRoutes) => {
      orderRoutes.forEach((orderRoute) => {
        uniqueProtocols.add(orderRoute.protocol)
      })
    })
  })

  return Array.from(uniqueProtocols)
}

export function findAllUniqueProtocolsAndMergeUniswap(
  routes: PercentRoute[],
): string[] {
  if (!routes || routes.length === 0) return []

  const uniqueProtocols = new Set<string>()

  routes.forEach((pathRoutes) => {
    pathRoutes.forEach((orderRoutes) => {
      orderRoutes.forEach((orderRoute) => {
        if (
          orderRoute.protocol === 'uniswap v2' ||
          orderRoute.protocol === 'uniswap v3'
        ) {
          uniqueProtocols.add('uniswap')
        } else {
          uniqueProtocols.add(orderRoute.protocol)
        }
      })
    })
  })

  return Array.from(uniqueProtocols)
}

export function getIsOrderContainsBebop(routes: PercentRoute[]) {
  if (!routes || routes.length === 0) return false

  return routes.some((pathRoutes) =>
    pathRoutes.some((orderRoutes) =>
      orderRoutes.some((orderRoute) => orderRoute.protocol === 'bebop'),
    ),
  )
}

export function getPercentRoutesEntries(order: Order) {
  const routes = order?.routes
  if (!routes || routes.length === 0) {
    return []
  }

  const totalAmountIn = order?.amountIn
  let totalPercentage = 0

  const percentRoutes = routes.map((percentRoute, index) => {
    const subTotalAmountIn = percentRoute[0].reduce(
      (total, orderRoute) => total + parseFloat(orderRoute.amountIn),
      0,
    )
    if (index === routes.length - 1) {
      return { percentRoute, percentage: 100 - totalPercentage }
    } else {
      const percentage = Math.floor(
        (subTotalAmountIn / parseFloat(totalAmountIn)) * 100,
      )
      totalPercentage += percentage
      return { percentRoute, percentage }
    }
  })

  return percentRoutes
}
